module.exports = __webpack_public_path__ + "static/media/fondo.2e70f448.png";